import { SVGProps, Ref, forwardRef } from 'react'
const SvgTrustedContact = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.125 4.875a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM7.5 0a4.875 4.875 0 0 0-2.8 8.866A7.499 7.499 0 0 0 0 15.824v1.294c0 .414.336.75.75.75h7.5a.75.75 0 0 0 0-1.5H1.5v-.544a6 6 0 0 1 6-6c.978 0 1.942.233 2.813.68a.75.75 0 1 0 .684-1.335 7.666 7.666 0 0 0-.686-.31A4.875 4.875 0 0 0 7.5 0Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.25 15.75a7.669 7.669 0 0 1-6 7.5 7.669 7.669 0 0 1-6-7.5V12.5c4-2.765 8-2.765 12 0v3.25Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.227 13.944-2.905 3.874a.752.752 0 0 1-1.13.08l-1.5-1.5"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTrustedContact)
export default ForwardRef
